import React from 'react';
import { useTranslation } from 'react-i18next';
import { type StackItem } from '../types';

interface StackInspectorProps {
  stack: StackItem;
}

export const StackInspector: React.FC<StackInspectorProps> = ({ stack }) => {
  const { t } = useTranslation();

  return (
    <div className="bg-[#0A0D15] border border-[#00F0FF]/30 p-6 relative font-mono h-full flex flex-col justify-between">
      <div className="absolute top-0 right-0 bg-[#00F0FF] text-[#07090E] text-[10px] font-bold px-2 py-0.5">
        {t('inspector.badge')}
      </div>

      <div className="space-y-6">
        <div>
          <span className="text-xs text-gray-500">{t('inspector.header')}</span>
          <h3 className="text-2xl font-bold text-[#00F0FF] mt-1">{stack.name}</h3>
          <p className="text-xs text-gray-400 mt-1">
            {t('inspector.categoryLabel')} {stack.category}
          </p>
        </div>

        <div className="border-t border-gray-800 pt-4 space-y-3 text-xs">
          <div>
            <span className="text-gray-500 block mb-1">{t('inspector.expLevelLabel')}</span>
            <span className="text-white font-semibold">{stack.experience}</span>
          </div>

          <div>
            <span className="text-gray-500 block mb-1">{t('inspector.practicalAppLabel')}</span>
            <p className="text-gray-300 font-sans text-sm leading-relaxed">
              {stack.highlight}
            </p>
          </div>
        </div>

        <div className="bg-[#07090E] p-4 border border-gray-800 text-xs text-gray-400 space-y-2">
          <div className="text-gray-500 text-[10px]">{t('inspector.techNoteHeader')}</div>
          <p className="font-sans leading-relaxed">
            {t('inspector.techNoteText')}
          </p>
        </div>
      </div>

      <div className="flex items-center justify-between pt-4 mt-4 border-t border-gray-800 text-xs text-gray-500">
        <span>ID: {stack.id.toUpperCase()}</span>
        <span className="text-[#00F0FF] font-semibold">{t('inspector.statusActive')}</span>
      </div>
    </div>
  );
};
